import { IApiResponseSuccess } from "core/networks/Interfaces";

export enum TEMPLATE_ENUM {
    ACTION_REMIND_PUSH_LAST_LOGIN_0 = "ACTION_REMIND_PUSH_LAST_LOGIN_0",
    ACTION_REMIND_PUSH_LAST_LOGIN_1 = "ACTION_REMIND_PUSH_LAST_LOGIN_1",
    ACTION_REMIND_PUSH_LAST_LOGIN_2 = "ACTION_REMIND_PUSH_LAST_LOGIN_2",
    ACTION_DAILY_MEAL_SUGGESTION = "ACTION_DAILY_MEAL_SUGGESTION",
}

export interface Data {
    id: number;
    name: string;
    description: string;
}

export interface NotificationData {
    title: string;
    content: string;
    request_id: string;
}

export interface NotificationHistory {
    id: number;
    push_id: number;
    user_id: number;
    lang_id: number;
    read_status: string;
    created_at: string;
    updated_at: string;
}

export interface Notification {
    id: number;
    type: string;
    template: TEMPLATE_ENUM;
    data: NotificationData;
    action: string;
    author_id: number | null;
    created_at: string;
    updated_at: string;
    title: string;
    content: string;
    histories: NotificationHistory[];
}

export type NotificationListResponse = IApiResponseSuccess<Notification[]>
